
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PaymentInfoForm from './PaymentInfoForm';

interface PaymentInfoCardProps {
  userId: string;
}

const PaymentInfoCard: React.FC<PaymentInfoCardProps> = ({ userId }) => {
  return (
    <Card className="border-t-4 border-t-purple-DEFAULT">
      <CardHeader>
        <CardTitle className="text-xl text-purple-dark">Your Payment Information</CardTitle>
      </CardHeader>
      <CardContent>
        <PaymentInfoForm userId={userId} />
      </CardContent>
    </Card>
  );
};

export default PaymentInfoCard;
